/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTSVG } from '../../helpers'
import { Dropdown1 } from '../content/dropdown/Dropdown1'
import { getCSS, getCSSVariableValue } from '../../assets/ts/_utils'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'
import { channel } from 'diagnostics_channel'
import * as Yup from 'yup'
import { useState } from 'react'
import { LanguageHelp, getConfig } from '../../../_metronic/helpers/LanguageHelper'
import { Formik, FieldArray, useFormik, Form, Field, FieldProps } from 'formik'
import { addOrUpdateChannel, deleteChannel } from '../../../app/modules/auth/core/_requests';
import { toast } from 'react-toastify'
import { toAbsoluteUrl } from '../../helpers'
import { formatDate } from '../../../_metronic/helpers/utility'
import clsx from 'clsx'
import { useChannelRequest } from '../../../app/modules/apps/artificial-intelligence/review-list/core/ChannelRequestProvider'
import { DeleteChannelModal } from '../../../_metronic/partials'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'

const animatedComponents = makeAnimated();

type Props = {
  id: string
  channel?: ChannelFormDto
  functionDelete?: any
}

function getColor(color: string) {
  return "#" + color;
}

export class ChannelFormDto { type = 1; channelName = ""; searchQuery = ""; searchQueryList: object[] = []; searchQueryExceptionList: object[] = []; id = ""; isAutoSearch = false; companyId = ""; searchUrl = ""; expirationTime = "1 year"; token = ""; tokenExpirationDate = new Date(); isCompetitor = false; competitorName = ""; }

const ChannelForm: React.FC<Props> = ({ id, channel = new ChannelFormDto(), functionDelete }) => {

  const lang = getConfig()

  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [loading, setLoading] = useState(false)
  const [collapse, setCollapse] = useState(false)
  const [channelForEdit, updateChannelForEdit] = useState(channel)
  const editChannelSchema = Yup.object().shape({
    channelName: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Channel Name is required')),
    competitorName: Yup.string().when('isCompetitor',
      (isCompetitor, schema) => {
        if (isCompetitor == true) {
          return schema
            .min(3, LanguageHelp('Minimum 3 symbols'))
            .max(50, LanguageHelp('Maximum 50 symbols'))
            .required(LanguageHelp('Competitor name is required'))
        } else {
          return schema;
        }
      }),
    type: Yup.string()
      .required(LanguageHelp('Channel type is required')),
    searchUrl: Yup.string().when('type',
      (type, schema) => {
        if (type == 3 || type == 5) { // 10:Sikayetvar, 5:Ekşi
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .url(LanguageHelp('The text you enter must be the url'))
            .required(LanguageHelp('Search url is required'))
        } else {
          return schema;
        }
      }),
    searchQuery: Yup.string().when('type',
      (type, schema) => {
        if (type == 8) { // 8:Youtube
          return schema.min(24, LanguageHelp('Must be exactly 24 digits')).max(24, LanguageHelp('Must be exactly 24 digits'))
            .required(LanguageHelp('Channel Id is required'))
        }
        else if (type == 9) { // 9:Reddit
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .max(21, LanguageHelp('Maximum 21 symbols'))
            .matches("^[a-zA-Z0-9_]*$", "Subreddit name is wrong")
            .required(LanguageHelp('Subreddit name is required'))
        }
        else if (type == 10) { // 10:Instagram_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Instagram username is required'))
        }
        else {
          return schema;
        }
      }),
    searchQueryList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2 || type == 9 || type == 11) { // 2:Twitter, 9:Reddit, 11:Instagram_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 7) { // 7:Instagram_Comments
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    searchQueryExceptionList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2) { // 2:Twitter
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-zA-Z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        if (type == 7 || type == 11) { // 7:Instagram_Comments 11:Instagram_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    searchHashtagList: Yup.array().when('type',
      (type, schema) => {
        if (type == 7) {
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
            // Rest of your amenities object properties
          }))
        } else {
          return schema;
        }
      }),
    expirationTime: Yup.string().when('type',
      (type, schema) => {
        if (type == 6) {
          return schema.required(LanguageHelp('Expiration time is required'))
        } else {
          return schema;
        }
      }),
  })
  let url = ""
  if (channel.type === 2) {
    url = "/media/svg/brand-logos/twitter.svg"
  }
  else if (channel.type === 4) {
    url = "/media/svg/brand-logos/facebook-3.svg"
  }
  else if (channel.type === 5) {
    url = "/media/svg/brand-logos/eksisozluk.svg"
  }
  else if (channel.type === 3) {
    url = "/media/svg/brand-logos/sikayetvar.png"
  }
  else if (channel.type === 7) {
    url = "/media/svg/brand-logos/instagram-2-1.svg"
  }
  else if (channel.type === 8) {
    url = "/media/svg/brand-logos/youtube.svg"
  }
  else if (channel.type === 9) {
    url = "/media/svg/brand-logos/reddit.svg"
  }
  else if (channel.type === 10) {
    url = "/media/svg/brand-logos/instagram-comments.png"
  }
  else if (channel.type === 11) {
    url = "/media/svg/brand-logos/tiktok-sharing.png"
  }
  else if (channel.type === 12) {
    url = "/media/svg/brand-logos/tiktok-comments.png"
  }
  else
    url = "/media/svg/general/api-cloud.svg"

  const formik = useFormik({
    initialValues: channelForEdit,
    validationSchema: editChannelSchema,
    validateOnMount: true,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        var queryList: string[] = []
        values.searchQueryList.forEach(searchQuery => {
          queryList.push(Object(searchQuery)['label'])
        });
        var queryExceptionList: string[] = []
        values.searchQueryExceptionList.forEach(searchQueryException => {
          queryExceptionList.push(Object(searchQueryException)['label'])
        });
        var addOrUpdateChannelResult = await addOrUpdateChannel(values.id, values.channelName, values.companyId, values.searchQuery, values.type, values.searchUrl, values.isAutoSearch, queryList, queryExceptionList, values.expirationTime, values.isCompetitor, values.competitorName)

        updateChannelForEdit({
          ...channelForEdit,
          token: addOrUpdateChannelResult.data.result.token,
          tokenExpirationDate: addOrUpdateChannelResult.data.result.tokenExpirationDate,
        })

        setLoading(false)

        if (addOrUpdateChannelResult.data.httpStatusCode === 400) {
          console.error(addOrUpdateChannelResult.data.message)
        }
        else {
          toast.success(LanguageHelp("The channel has been successfully updated."))
        }

      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    },
  })

  return (
    <div>
      <div key={"mainDiv" + channel.id} className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target={'#kt_account_profile_details' + channel.id}
          aria-expanded='true'
          aria-controls={'kt_account_profile_details' + channel.id}
          onClick={(e) => { setCollapse(!collapse) }}
        >
          <div className='d-flex align-items-center'>
            {/* begin:: Avatar */}
            <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
              <a href='#'>
                <div className='symbol-label'>
                  <img src={toAbsoluteUrl(url)} className='w-100' />
                </div>
              </a>
            </div>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{formik.values.channelName}</h3>

            </div>

          </div>
          <div className='btn btn-sm btn-icon btn-active-color-primary align-self-end mb-5'>
            {collapse && (
              <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-1' />
            )}
            {!collapse && (
              <KTSVG path='/media/icons/duotune/arrows/arr073.svg' className='svg-icon-1' />
            )}
          </div>

        </div>

        <div id={'kt_account_profile_details' + channel.id} className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className={'card-body border-top p-9'}>

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Channel Name')}</label>
                  <div className='col-lg-8 fv-row'>
                    <input
                      placeholder={LanguageHelp('Channel Name')}
                      {...formik.getFieldProps('channelName')}
                      type='text'
                      name='channelName'
                      className={clsx('form-control form-control-lg form-control-solid')}
                      autoComplete='off'
                      disabled={formik.isSubmitting}
                    />
                    {formik.touched.channelName && formik.errors.channelName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.channelName}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* end::Input group */}

              <div id='kt_modal_add_user_scroll' data-kt-scroll='true' >
                {(channel.type === 2) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Twitter Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}

                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 7) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Instagram Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}

                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(channel.type === 1) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <div className='notice d-flex bg-light-success rounded border-warning border border-dashed mb-6 p-6'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-2tx svg-icon-success me-4'
                        />

                        <div className='d-flex flex-stack flex-grow-1'>
                          <div className='fw-bold'>
                            <div className='fs-6 text-gray-600'>
                              {LanguageHelp('Click on the link to access the commands of the API, try it on the site or download it as a collection for postman.')}
                              <a href='https://aiapi.aisenseus.net' target='_blank' className='text-gray-800 text-hover-primary' >
                                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 9)) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Subreddit Name')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Subreddit Name')}
                            {...formik.getFieldProps('searchQuery')}
                          />
                          {formik.touched.searchQuery && formik.errors.searchQuery && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Queries to search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 3) || (channel.type === 5)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Url to search')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Url to search')}
                          {...formik.getFieldProps('searchUrl')}
                        />
                        {formik.touched.searchUrl && formik.errors.searchUrl && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchUrl}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 10)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 8)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Youtube Channel Id')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Youtube Channel Id')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 11) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked TikTok Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 12)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('TikTok Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('TikTok Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((channel.type === 2) || (channel.type === 3) || (formik.values.type == 5) || (channel.type === 7) || (channel.type === 8) || (channel.type === 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12)) &&
                  <div className='col-lg-8 fv-row'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isAutoSearch')}
                        checked={formik.values.isAutoSearch}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isAutoSearch'>
                        {LanguageHelp('I want daily data collection.')}
                      </label>
                    </div>
                    {formik.touched.isAutoSearch && formik.errors.isAutoSearch && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.isAutoSearch}</div>
                      </div>
                    )}

                  </div>
                }
                {((formik.values.type == 2) || (formik.values.type == 3) || (formik.values.type == 5) || (formik.values.type == 7) || (formik.values.type == 8) || (formik.values.type == 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12)) &&
                  <div className='mt-6'>
                    <div className='col-lg-8 fv-row'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isCompetitor')}
                          checked={formik.values.isCompetitor}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isCompetitor'>
                          {LanguageHelp('This is a competitor channel.')}
                        </label>
                      </div>
                      {formik.touched.isCompetitor && formik.errors.isCompetitor && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isCompetitor}</div>
                        </div>
                      )}
                    </div>
                    {(formik.values.isCompetitor == true) &&
                      <div className='fv-row mb-7'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Competitor Name')}</label>
                          <div className='col-lg-8 fv-row'>
                            <input
                              placeholder={LanguageHelp('Competitor Name')}
                              {...formik.getFieldProps('competitorName')}
                              type='text'
                              name='competitorName'
                              className={clsx('form-control form-control-lg form-control-solid')}
                              autoComplete='off'
                              disabled={formik.isSubmitting}
                            />
                            {formik.touched.competitorName && formik.errors.competitorName && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.competitorName}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                      </div>
                    }
                  </div>
                }

                {(formik.values.type == 6) &&
                  <div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Expiration Date')}</label>
                      <label className='col-lg-8 col-form-label fv-row'>
                        {formatDate(channelForEdit.tokenExpirationDate, lang.selectedLang)}
                      </label>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('New Expiration Time')}</label>
                      <div className='col-lg-8 fv-row'>
                        <select
                          className='form-select form-select-solid form-select-lg'
                          {...formik.getFieldProps('expirationTime')}
                          onChange={formik.handleChange}
                        >
                          <option value=''>{LanguageHelp('Select a time to update the expiration date')}</option>
                          <option value='1 month'>{LanguageHelp('1 month')}</option>
                          <option value='3 month'>{LanguageHelp('3 month')}</option>
                          <option value='6 month'>{LanguageHelp('6 month')}</option>
                          <option value='1 year'>{LanguageHelp('1 year')}</option>
                          <option value='2 year'>{LanguageHelp('2 year')}</option>
                          <option value='3 year'>{LanguageHelp('3 year')}</option>
                        </select>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <div className='notice d-flex bg-light-success rounded border-warning border border-dashed mb-6 p-6'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-2tx svg-icon-success me-4'
                        />

                        <div className='d-flex flex-stack flex-grow-1'>
                          <div className='fw-bold'>
                            <div className='fs-6 text-gray-600'>
                              {LanguageHelp('To run the IFrame, simply add the following codes to your web page.')}
                            </div>
                            <div className='fs-7 col-form-label'>
                              {'<iframe id="aiframe" name="aiframe" src="aiframe_reports.html?token=' + channelForEdit.token + '" width="400" height="800" frameborder="0"></iframe>'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <DeleteChannelModal functionDelete={functionDelete} id={id} />
              <button type='button' className='btn btn-danger' data-bs-toggle='modal' data-bs-target='#kt_modal_channel_delete'>
                {LanguageHelp('Delete')}
              </button>
              <button type='submit' className='btn btn-primary ms-3' disabled={formik.isSubmitting || !formik.isValid || !formik.touched}>
                {!loading && LanguageHelp('Save')}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {LanguageHelp('Please Wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div >
      </div >
    </div >
  )
}

export { ChannelForm }